module.exports = __webpack_public_path__ + "img/logo.1a95b6df.png";